/* unplugin-vue-components disabled */import script from "./Iframe.vue?vue&type=script&setup=true&lang=js"
export * from "./Iframe.vue?vue&type=script&setup=true&lang=js"

import "./Iframe.vue?vue&type=style&index=0&id=bee10ab8&lang=less&scoped=true"

import exportComponent from "/Users/kummy/Documents/xsyx/grape-setting/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bee10ab8"]])

export default __exports__